import React, { useCallback, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, LogOutIcon, SettingsIcon } from 'lucide-react';
import { useAdminData } from '../../../contexts/AdminDataContext';
import { useDismiss } from '../../../hooks/useDismiss';
import { owner } from '../../../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
export function ProfileMenu({
  onLogout
}: {
  onLogout: () => void;
}) {
  const {
    user
  } = useAdminData();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(wrapRef, open, close);
  const firstName = owner.name.split(' ')[0];
  return <div ref={wrapRef} className="relative" data-id="element-441" data-mp="yddu1j3s7hjw">
      <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label="Brugermenu" className="flex items-center gap-2.5 rounded-xl py-1 pl-1 pr-2 transition-colors duration-150 ease-smooth hover:bg-white" data-id="element-442" data-mp="1m4jcm613wnxw">
        <img src={owner.portrait} alt="" className="h-8 w-8 rounded-full object-cover ring-1 ring-line" data-id="element-443" data-mp="3onejne40fl8n" />
        <span className="hidden text-[15px] font-medium text-ink lg:inline" data-id="element-444" data-mp="6aq48f9hu7cs">{firstName}</span>
        <ChevronDownIcon className="hidden h-4 w-4 text-ink-muted lg:block" aria-hidden="true" data-id="element-445" data-mp="1hnao74puxwl" />
      </button>

      <AnimatePresence data-id="element-446" data-mp="g5rw3iv5lnj2">
        {open && <motion.div initial={{
        opacity: 0,
        y: -4,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -4,
        scale: 0.98
      }} transition={{
        duration: 0.16,
        ease
      }} className="absolute right-0 top-[calc(100%+8px)] z-50 w-60 origin-top-right overflow-hidden rounded-xl border border-line bg-white shadow-lift" data-id="element-447" data-mp="b8i5hzw135tn">
            <div className="border-b border-line px-4 py-3" data-id="element-448" data-mp="2myaq7vrkp0jw">
              <p className="text-sm font-semibold text-ink" data-id="element-449" data-mp="2mzvnvu96ozlz">{owner.name}</p>
              {user?.email && <p className="truncate text-xs text-ink-muted" data-id="element-450" data-mp="pyzlbbw03khz">{user.email}</p>}
            </div>
            <Link to="/admin/indstillinger" onClick={close} className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-ink-soft transition-colors duration-100 hover:bg-canvas-deep hover:text-ink" data-id="element-451" data-mp="uwhsawqgjpnc">
              <SettingsIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-452" data-mp="18wsli6f8pgbo" />
              Indstillinger
            </Link>
            <button type="button" onClick={() => {
          close();
          onLogout();
        }} className="flex w-full items-center gap-2.5 px-4 py-2.5 text-left text-sm text-ink-soft transition-colors duration-100 hover:bg-canvas-deep hover:text-ink" data-id="element-453" data-mp="1dtj1ktr1obx3">
              <LogOutIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-454" data-mp="1si6v6uhbybke" />
              Log ud
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}